<template>
    <!-- 机构开通申请 -->
    <div class="mechanismOpenApply">
        <div class="search_container">
            <el-form size="mini" ref="form" class="searchBox" :inline="true" :model="orgData">
                <el-form-item label="名称">
                    <el-input v-model="orgData.content" @change="getMechanismOpenApplyList(1)" clearable placeholder="请输入计划或机构名称"></el-input>
                </el-form-item>
                <el-form-item label="专业类型" class="mySelect">
                    <el-select v-model="orgData.professionId" @change="getMechanismOpenApplyList(1)" @clear="() => orgData.raceType = ''" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in ProfessionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="大赛类型" class="mySelect">
                    <el-select v-model="orgData.raceType" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in RaceTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省份" class="mySelect">
                    <el-select v-model="orgData.provinceId" @change="getMechanismOpenApplyList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" class="mySelect">
                    <el-select v-model="orgData.status" clearable @change="getMechanismOpenApplyList(1)" placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in PlanStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button size="mini" type="primary" @click="getMechanismOpenApplyList(1)">查询</el-button>

        </div>
        <div class="comPractice_container">
            <div class="button_box">
                <el-button type="primary" @click="() => {importInsListVisble = true}" size="mini">批量申请机构</el-button>
                <el-button type="primary" @click="exportAccount" size="mini">导出账号</el-button>
                <el-button type="primary" @click="submitBtn('bath')" size="mini">批量提交</el-button>
                <el-button type="primary" @click="withdrawBtn('bath')" size="mini">批量撤回</el-button>
                <!-- <el-button type="primary" @click="exportBtn" size="mini">导出账号</el-button> -->
                <el-button type="primary" size="mini" @click="getNewApplyBtn">新建申请</el-button>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' ref="mechanismBasicTable" :tableHeader="mechanismOpenApplyHeader" :tableData="tableData" @operation="operation">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <!-- 
                        // 0 - 未提交 （当为未提交状态时，机构可进行编辑或提交操作)
                        // 1 - 待审批 (当为待审批状态时，机构可进行撤回操作，并且中心可进行 通过/驳回 的操作, 一旦中心操作后，则机构不可进行撤销操作)
                        // 2 - 已通过 (通过后可进行账户的维护)
                        // 3 - 已驳回 (驳回后,机构可进行编辑，并重新提交)
                     -->
                    <el-button size="mini" v-if="data.row.status == 3 || data.row.status == 0" @click="submitBtn('single', data.row)" type="text">提交</el-button>
                    <el-button size="mini" @click="editBtn(data.row)" type="text">编辑</el-button>
                    <el-button size="mini" v-if="data.row.status == 1" @click="withdrawBtn('single', data.row)" type="text">撤回</el-button>
                    <el-button size="mini" v-if="data.row.status == 2" @click="accountBtn(data.row)" type="text">账号</el-button>
                    <el-button size="mini" v-if="data.row.status == 3 || data.row.status == 0" @click="deleteApplyBtn(data.row)" type="text">删除</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination>
        </div>

        <!-- 新建申请 -->
        <el-dialog title="新建申请" :visible.sync="addApplyDialogVisible" :close-on-click-modal="false" class="addPlanDialog" width="800px" :before-close="AddhandleClose">
            <div class="dialog_search">
                <el-form :hide-required-asterisk="true" size="mini" ref="newPlanFormOne" :inline="true" :model="planData">
                    <div class="formcenter">
                        <el-form-item label="选择计划">
                            <el-select v-model="planData.id" clearable filterable placeholder="全部" @clear="clearPlan" @change="changePlan">
                                <el-option v-for="item in selectPlanList" :key="item.id" :label="item.schemeName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                        <div class="planInfo">
                            <div class="planInfo_top">
                                <div class="left">专业类别: &nbsp;&nbsp;&nbsp; {{planInfoData.professionName || '    -  '}}</div>
                                <div class="right">大赛类型:&nbsp;&nbsp;&nbsp; {{planInfoData.raceName || '    -    '}}</div>
                            </div>
                            <div class="planInfo_bottom">
                                <!-- 开通时段: &nbsp;&nbsp;&nbsp; {{planInfoData.beginTime || '    -  '}} - {{planInfoData.endTime || '    -  '}} -->
                                开通时段: &nbsp;&nbsp;&nbsp; {{provinceFormData.beginTime || '    -  '}} - {{provinceFormData.endTime || '    -  '}}
                            </div>
                        </div>
                    </div>
                    <div>
                        选择机构
                    </div>

                    <div class="mechanism">
                        <div class="mechanism_left">
                            <div class="mechanismToptitle">
                                <div class="left_box">
                                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="changeCheckBtn"> <span style="color: #409EFF">{{checkedList.length}}/{{orgList.length}} 条</span></el-checkbox>
                                </div>
                                <div class="right_box">备选机构</div>
                            </div>
                            <div class="mechanismBottomMin">
                                <div class="mechanismSearch">
                                    <el-input size="mini" suffix-icon="el-icon-search" v-model="content" style="width: 135px" @input="changeContent" clearable placeholder="请输入机构名称"></el-input>
                                    <el-select size="mini" v-model="provinceId" placeholder="全部" style="width: 90px;" @change="changeProvince" @clear="clearProvince">
                                        <el-option v-for="item in provinceList" :key="item.id" :label="item.provinceName" :value="item.provinceId"></el-option>
                                    </el-select>
                                    <el-select size="mini" v-model="raceType" clearable placeholder="全部" style="width: 90px;" @change="changeRacesType">
                                        <el-option v-for="item in OrgTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <div class="mechanismTable">
                                    <el-checkbox-group v-model="checkedList" @change="handleCheckedChange">
                                        <el-checkbox v-for="item in orgList" :label="item" :key="item.id" :disabled="item.status != null">
                                            <div class="mechanismOrgName" :title="item.orgName">{{item.orgName}}</div>
                                            <div class="selectText" :title="item.provinceName">{{item.provinceName}}</div>
                                            <div class="selectText2" :title="item.orgTypeName">{{item.orgTypeName}}</div>
                                            <!-- <div style="margin-top: 10px;"></div> -->
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>

                        </div>
                        <div class="mechanism_center">
                            <div class="arrow_left el-icon-arrow-right" @click="addArrowLeftBtn"></div>
                            <div class="arrow_right el-icon-arrow-left" @click="removeArrowRightBtn"></div>
                        </div>
                        <div class="mechanism_right">
                            <div class="mechanismToptitle">
                                <div class="left_box">
                                    <el-checkbox :indeterminate="isIndeterminateTwo" @change="changeCheckBtnTwo" v-model="checkAllTwo"></el-checkbox>
                                </div>

                                <div class="right_box"><span style="color: #409EFF">{{orgListTwo.length || 0 }} 条</span> &nbsp;&nbsp;&nbsp;已选机构</div>
                            </div>
                            <div class="mechanismBottomMin">
                                <div class="mechanismSearch">
                                    <el-input size="mini" suffix-icon="el-icon-search" v-model="rightData.orgName" @input="righSearchDialogtDataFun" style="width: 135px" clearable placeholder="请输入机构名称"></el-input>
                                    <el-select size="mini" v-model="rightData.provinceId"  @clear="righSearchDialogtDataFun" clearable  placeholder="全部" style="width: 90px;" @change="righSearchDialogtDataFun">
                                        <el-option v-for="item in provinceListTwo" :key="item.id" :label="item.provinceName" :value="item.provinceId"></el-option>
                                    </el-select>
                                    <el-select size="mini" v-model="rightData.orgTypeId" clearable placeholder="全部" style="width: 90px;" @change="righSearchDialogtDataFun">
                                        <el-option v-for="item in OrgTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <div class="mechanismTable2">
                                    <el-checkbox-group v-model="checkedListTwo" @change="handleCheckedRightChange">
                                        <el-checkbox v-for="item in orgListTwo" :label="item" :key="item.id" >
                                            <div class="mechanismOrgName" :title="item.orgName">{{item.orgName}}</div>
                                            <div class="selectText" :title="item.provinceName">{{item.provinceName}}</div>
                                            <div class="selectText2" :title="item.orgTypeName">{{item.orgTypeName}}</div>
                                            <!-- <div style="margin-top: 10px;"></div> -->
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelAddApplyDialogVisible">取 消</el-button>
                <el-button  size="mini" type="primary" @click="makeAddApplyDialogVisible">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisibale" :close-on-click-modal="false" class="editDialog" width="590px" :before-close="AddhandleClose">
            <div class="dialog_contenter">

                <el-form ref="editData" :model="editData" label-width="100px">
                    <el-form-item label="大赛练习计划:">
                        {{editData.schemeName || '-'}}
                    </el-form-item>
                    <div class="editCenterTwoBox">
                        <el-form-item label="专业类别:">
                            {{editData.professionName || '-'}}
                        </el-form-item>
                        <el-form-item label="大赛分类:">
                            {{editData.raceTypeName || '-'}}
                        </el-form-item>
                    </div>
                    <el-form-item label="计划时间:">
                        {{editData.beginTime || '-'}} - {{editData.endTime || '-'}}
                    </el-form-item>
                    <el-form-item label="机构名称:">
                        {{editData.orgName || '-'}}
                    </el-form-item>
                    <div class="editCenterTwoBox">
                        <el-form-item label="所属省份:">
                            {{editData.provinceName || '-'}}
                        </el-form-item>
                        <el-form-item label="院校类型:">
                            {{editData.orgTypeName || '-'}}
                        </el-form-item>
                    </div>
                    <el-form-item label="联系人姓名:">
                        <el-input style="width: 200px;" maxlength="30" v-model="editData.person" size="mini" placeholder="请输入机构联系人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人电话:" prop="phone">
                        <el-input style="width: 200px;" v-model="editData.phone" size="mini" placeholder="请输入机构联系人电话"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelBtn">取 消</el-button>
                <el-button size="mini" type="primary" @click="editSaveBtn">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 账号 -->
        <el-dialog title="账号管理" :visible.sync="accountDialogVisibale" :close-on-click-modal="false" class="accountDialog" width="590px" :before-close="AddhandleClose">
            <div class="dialog_contenter">
                <div class="reason">默认密码123456, 首次登陆强制修改密码</div>
            </div>

            <basic-table v-loading="loadingCopy" :isCheckbox='false' :tableHeader="accountManageHeader" :tableData="accounTableData">
                <template slot-scope="data">
                    <el-button size="mini" @click="resetPasswordBtn(data.row)" type="text">重置密码</el-button>
                </template>
            </basic-table>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="accountDialogVisibale = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 批量申请机构 -->
        <basic-dialog :importInsListVisble="importInsListVisble" @changeimportInsListVisble="changeimportInsListVisble" :uploadUrl="uploadUrl" :isApplication="false"></basic-dialog>

    </div>
</template>

<script>
import { mechanismOpenApplyHeader, accountManageHeader } from './globalData'
import fetch from '@/api/fetch'
import axios from 'axios'
// import { checkPhone } from '@/utils/common.js'

export default {
    name: 'mechanismOpenApply',

    data() {
        // var checkPhoneUsual = (rule, value, callback) => {
        //     if (value == '') {
        //         console.log('kkk')
        //         this.editSaveFun()
        //     } else {
        //         console.log('ll')
        //         checkPhone(rule, value, callback)
        //     }
        // }
        return {
            // 左侧dialog数据
            checkAll: false,
            isIndeterminate: null,
            content: '',
            provinceId: '',
            raceType: '',
            checkedList: [], // 获取到的左侧选择的机构
            orgList: [],
            // 右侧dialog数据
            isIndeterminateTwo: false,
            checkAllTwo: false,
            rightData: {
                orgTypeName: '',
                provinceId: '',
                orgTypeId: ''
            },
            checkedListTwo: [], // 获取到的右侧选择的机构
            orgListTwo: [],
            orgKeyIdList: [],
            provinceListTwo: [],
            OrgTypeList: [], // 机构类型
            accounTableData: [], // 账号管理Table
            mechanismOpenApplyHeader: mechanismOpenApplyHeader,
            accountManageHeader: accountManageHeader,
            tableData: [],
            provinceData: [],
            orgData: {
                raceType: '',
                professionId: '',
                content: '',
                status: '',
                provinceId: ''
            },
            pageNo: 1,
            limitSize: 10,
            editDialogVisibale: false,
            idList: [],
            schemeId: 1, // 大计划Id null
            planInfoData: {},
            planData: {
                id: ''
            }, // 计划信息
            planList: [],
            PlanStatus: [ // 0 未发布 1 未开始 2进行中 3 已结束
                { id: 0, name: '未提交', value: 0 },
                { id: 1, name: '待审批', value: 1 },
                { id: 2, name: '已通过', value: 2 },
                { id: 3, name: '已驳回', value: 3 },
            ],
            total: 0,
            ProfessionList: [],
            RaceTypeList: [],
            loading: false,
            loadingCopy: false,
            addApplyDialogVisible: false,
            accountDialogVisibale: false,
            selectPlanList: [], // dialog选择计划下拉列表
            provinceList: [],
            provinceFormData: {},
            editData: {
                person: null,
                phone: null,
            },
            orgListThree: [],
            // editData: {},// 编辑信息
            applyId: '', //申请Id
            wantfilterData: [], // 想要过滤的数据
            rowData: {},
            openId: '',
            // editDataRules: {
            //     phone: [{ validator: checkPhoneUsual, trigger: 'blur' }]
            // }
            importInsListVisble: false, // 导入机构
            uploadUrl: 'https://zledu-sx.oss-cn-beijing.aliyuncs.com/cjdd/matchSignup/template/批量申请计划模板.xlsx'
        };
    },

    mounted() {
        this.openId = JSON.parse(sessionStorage.getItem('userData')).openId
        console.log( this.openId , ' this.openId ')
        this.getProfessionListUrl()
        this.getOrgTypeListUrl()
        this.getProvinceList()
        this.getMechanismOpenApplyList()
    },


    methods: {
        changeimportInsListVisble(val) {
            this.importInsListVisble = val
        },
        makeAddApplyDialogVisible() {
            if(this.orgListThree.length <= 0 ) {
                this.$message.error('请添加到已选机构列表中, 进行新建申请操作')
            } else {
                let data = this.orgListThree.map(item => {
                    return { schemeId: this.planInfoData.id, professionId: this.planInfoData.professionId, raceType: this.planInfoData.raceType, orgKeyId: item.orgKeyId, orgName: item.orgName, provinceId: item.provinceId, orgTypeId: item.orgTypeId }
                })
                fetch.getSalerAddApply({ applyList: data }).then(res => {
                    if (res.code == '0') {
                        this.$message.success(res.msg)
                        this.getMechanismOpenApplyList()
                        this.planData.id = ''
                        this.checkedList = []
                        this.checkedListTwo = []
                        this.orgListTwo = []
                        this.orgList = []
                        this.provinceId = ''
                        this.content = ''
                        this.raceType = ''
                        this.rightData = {
                            content: '',
                            provinceId: '',
                            raceType: ''
                        }
                        this.OrgTypeList = []
                        this.provinceList = []
                        this.provinceListTwo = []
                        this.isIndeterminate = false
                        this.isIndeterminateTwo = false
                        this.checkAll = false
                        this.checkAllTwo = false
                        this.addApplyDialogVisible = false
                        this.planInfoData = {}
                        this.orgListThree = []
                        this.provinceFormData = {}
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        cancelAddApplyDialogVisible() {
            this.planData.id = ''
            this.checkedList = []
            this.checkedListTwo = []
            this.orgListTwo = []
            this.orgList = []
            this.provinceId = ''
            this.content = ''
            this.raceType = ''
            this.rightData = {
                content: '',
                provinceId: '',
                raceType: ''
            }
            this.OrgTypeList = []
            this.provinceList = []
            this.provinceListTwo = []
            this.isIndeterminate = false
            this.isIndeterminateTwo = false
            this.checkAll = false
            this.checkAllTwo = false
            this.addApplyDialogVisible = false
            this.planInfoData = {}
            this.orgListThree = []
            this.provinceFormData = {}
        },
        righSearchDialogtDataFun() {
            this.checkedListTwo = []
            
            // 备份了一下数据去重
            let arr = this.orgListThree.filter(item => {
                let idList= this.checkedListTwo.map(v => v.id)
                return !idList.includes(item.id)
            })


            // 通过遍历key值来循环处理
            // 前端搜索
            Object.keys(this.rightData).forEach(e => {
                // 调用自己定义好的筛选方法
                arr = this.filterFunc(this.rightData[e], e, arr)
            })
            // 赋值
            this.orgListTwo = arr

            // this.orgListTwo = this.orgListTwo.filter(item => {
            //     let idList= this.orgList.map(v => v.id)
            //     return !idList.includes(item.id)
            // })
            // console.log(this.orgListTwo)

        },
        // val: 查询条件的值
        // target: 目标参数，就是你这个值对应的key
        // filterarr: 被筛选的数组
        filterFunc(val, target, filterArr) {
            // 参数不存在或为空时，就相当于查询全部
            if (val == undefined || val == '') return filterArr
            return filterArr.filter(p => (p[target].toString()).indexOf(val) > -1) // 可以自己加一个.toLowerCase()来兼容一下大小
        },
        changeCheckBtnTwo(val) {
            // console.log(val)
            if (val) {
                this.checkedListTwo = this.orgListTwo
                this.isIndeterminateTwo = true
            } else {
                this.checkedListTwo = []
                this.isIndeterminateTwo = null
            }
        },
        changeCheckBtn(val) {
            if (val) {
                this.checkedList = this.orgList
                this.checkAll = true

                let orgListCopy = this.orgList
                let notDel = orgListCopy.filter(item => {
                    if (item.status != null || (item.createUserId != null && item.createUserId != this.openId)) {
                        return { ...item }
                    }
                })
                if (notDel.length >= 1) {
                    let newarr = orgListCopy.filter((item => !notDel.some(ele => ele.id == item.id)))
                    this.checkedList = newarr
                    this.isIndeterminate = true
                } else {
                    this.checkedListTwo = this.orgListTwo
                    this.isIndeterminate = true
                }


            } else {
                this.checkedList = []
                this.isIndeterminate = null
            }

        },
        cancelBtn() {
            this.editDialogVisibale = false
            this.editData = {
                person: '',
                phone: ''
            }
        },
        // getAddEndOrgList(data) { // 获取dialog右侧数据接口
        //     const loading = this.$loading({
        //         target: document.querySelector('.mechanismTable2'),
        //         text: 'Loading',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.7)'
        //     });
        //     fetch.getAddEndOrgList(data).then(res => {
        //         if (res.code == '0') {
        //             loading.close()
        //             this.orgListTwo = res.data
        //         } else {
        //             loading.close()
        //             this.$message.error(res.msg)
        //         }
        //     })
        // },
        removeArrowRightBtn() {
            if (this.checkedListTwo.length <= 0) {
                this.$message.error('请选择右侧勾选的的机构')
            } else {
                // console.log(this.checkedListTwo, this.orgListTwo)
                // 删除右侧选中的相同学校 1  orgListThree是所有的数据
                // this.orgListThree.forEach((item,index) => {
                //     this.checkedListTwo.forEach((ele) => {
                //         if(item.id == ele.id) {
                //             this.orgListThree.splice(index, 1)
                //         }
                //     })
                // })

                this.orgListThree = this.orgListThree.filter(item => {
                    let idList= this.checkedListTwo.map(v => v.id)
                    return !idList.includes(item.id)
                })

                this.orgListTwo = this.orgListTwo.filter(item => {
                    let idList= this.checkedListTwo.map(v => v.id)
                    return !idList.includes(item.id)
                })

                
                // // 删除右侧选中的相同学校 2
                // this.orgListTwo.forEach((item,index) => {
                //     this.checkedListTwo.forEach((ele) => {
                //         if(item.id == ele.id) {
                //             this.orgListTwo.splice(index, 1)
                //         }
                //     })
                // })


                this.checkedListTwo = []
                this.checkedList = []


                this.isIndeterminateTwo = false
                this.checkAllTwo = false
                
                this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
                
                // this.checkedListTwo = []
                // this.checkedList = []
                // this.orgKeyIdList = this.checkedListTwo.map(item => {
                //     return item.orgKeyId
                // })

                // fetch.removeAddEndOrg({ schemeId: this.planInfoData.id, idList: this.orgKeyIdList }).then(res => {
                //     if (res.code == '0') {
                //         this.$message.success(res.msg)
                //         this.getAddEndOrgList({ id: this.planInfoData.id, provinceId: this.rightData.provinceId, content: this.rightData.content, raceType: this.rightData.raceType })
                //         this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
                //         this.getMechanismOpenApplyList()
                //         this.checkedListTwo = []
                //         this.checkedList = []
                //         this.orgKeyIdList = []
                //         this.isIndeterminateTwo = null
                //         this.checkAllTwo = false
                //     } else {
                //         this.$message.error(res.msg)
                //     }
                // })
            }
        },
        addArrowLeftBtn() {
            if (this.checkedList.length <= 0) {
                this.$message.error('请选择左侧能够勾选的的机构')
            } else {
                
                // 过滤数据 删除数组中相同的对象
                this.orgList = this.orgList.filter(item => {
                    let idList= this.checkedList.map(v => v.id)
                    return !idList.includes(item.id)
                })

                // console.log(this.orgListTwo, this.checkedList)

                this.orgListTwo.push(...this.checkedList)
                this.orgListThree.push(...this.checkedList)

                this.checkedList = []
                this.checkAll = false
                this.isIndeterminate = false
                this.rightData = {
                    raceType: '',
                    provinceId: '',
                    content: ''
                }
                this.righSearchDialogtDataFun()
                
                // let data = this.checkedList.map(item => {
                //     return { schemeId: this.planInfoData.id, professionId: this.planInfoData.professionId, raceType: this.planInfoData.raceType, orgKeyId: item.orgKeyId, orgName: item.orgName, provinceId: item.provinceId, orgTypeId: item.orgTypeId }
                // })

                // fetch.getSalerAddApply({ applyList: data }).then(res => {
                //     if (res.code == '0') {
                //         this.$message.success(res.msg)
                //         this.getAddEndOrgList({ id: this.planInfoData.id, provinceId: this.rightData.provinceId, content: this.rightData.content, raceType: this.rightData.raceType })
                //         this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
                //         this.getMechanismOpenApplyList()
                //         this.checkedList = []
                //         this.checkedListTwo = []
                //         this.isIndeterminate = null
                //         this.checkAll = false

                //     } else {
                //         this.$message.error(res.msg)
                //     }
                // })
            }
        },
        clearProvince() {
            this.orgList = []
            this.checkedList = []
        },
        changeProvince(val) {
            // console.log(val)
            this.isIndeterminate = false
            this.checkAll = false
            this.checkedList = []
            let time = this.provinceList.filter(item => {
                return item.provinceId == val
            })
            this.provinceFormData = time[0]
            this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
        },
        changeContent() {
            this.checkAll = false
            this.isIndeterminate = false
            this.checkedList = []
            this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
        },
        changeRacesType() {
            this.checkAll = false
            this.isIndeterminate = false
            this.checkedList = []
            this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType })
        },
        getDictOrglist(data) { // 获取dialog左侧数据接口
            const loading = this.$loading({
                target: document.querySelector('.mechanismTable'),
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            fetch.getDictOrglist(data).then(res => {
                if (res.code == '0') {

                    this.orgList = res.data.filter(item => {
                        let idList= this.orgListTwo.map(v => v.id)
                        return !idList.includes(item.id)
                    })

                    loading.close()
                } else {
                    this.$message.error(res.msg)
                    loading.close()
                }
            })
        },
        clearPlan() { // 清空计划
            this.orgList = []
            this.orgListTwo = []
            this.provinceId = ''
            this.provinceList = []
            this.checkedList = []
            this.checkedListTwo = []
            this.provinceListTwo = []
            this.OrgTypeList = []
            this.raceType = ''
            this.rightData.raceType = ''
            this.rightData.provinceId = ''
            this.checkAll = false
            this.isIndeterminateTwo = false
            this.checkAllTwo = false
            this.orgListThree = []
            this.provinceFormData = {}
            this.planInfoData = {}
            this.isIndeterminate = false
        },
        changePlan(val) { // 改变计划
            if (val) {
                let data = this.selectPlanList.filter(item => {
                    return item.id == val
                })
                //过滤下得到的选择该计划的所有信息 - 包括大计划id  - planInfoData
                this.planInfoData = data[0]
                this.getOrgTypeListUrl()
                this.orgListTwo = []
                this.provinceList = this.planInfoData.schemeProvinceList
                this.provinceListTwo = this.planInfoData.schemeProvinceList
                this.provinceFormData = this.provinceList[0]
                // console.log(this.provinceFormData, 'this.provinceFormData', this.provinceList)
                this.provinceId = this.provinceList[0].provinceId
                this.orgListThree = []
                this.checkedListTwo = []
                // 调用获取左侧chenkbox数据
                this.provinceList.length > 0 ? this.getDictOrglist({ id: this.planInfoData.id, provinceId: this.provinceId, content: this.content, raceType: this.raceType }) : false
                // 调用获取右侧chenkbox数据
                // this.provinceList.length > 0 ? this.getAddEndOrgList({ id: this.planInfoData.id, provinceId: this.rightData.provinceId, content: this.rightData.content, raceType: this.rightData.raceType }) : false

            }
        },
        getNewApplyBtn() { // 点击新建申请按钮
            this.addApplyDialogVisible = true
            this.getDeclareSchemeList()
        },
        editSaveBtn() {
            // editData

            this.$refs.editData.validate((valid) => {
                if (valid) {
                    this.editSaveFun()
                } else {
                    return false;
                }
            })
        },
        editSaveFun() {
            fetch.setUpdateApply({ applyId: this.applyId, person: this.editData.person, phone: this.editData.phone }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.editDialogVisibale = false
                    this.editData = {
                        person: null,
                        phone: null,
                    }
                    this.getMechanismOpenApplyList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        accountBtn(rowData) { // 账号管理Dialog
            this.rowData = rowData
            this.accountDialogVisibale = true
            this.getAccountList(rowData)
        },
        getAccountList(rowData) {
            this.loadingCopy = true
            fetch.getmanagerListAccount({ schemeId: rowData.schemeId, orgId: rowData.orgId }).then(res => {
                if (res.code == '0') {
                    this.loadingCopy = false
                    this.accounTableData = res.data
                } else {
                    this.loadingCopy = false
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.loadingCopy = false
            })
        },
        editBtn(data) { // 编辑
            this.applyId = data.id
            this.editDialogVisibale = true
            this.$nextTick(() => {
                this.$refs.editData.clearValidate()
            })
            fetch.getApplyInfoById({ applyId: data.id }).then(res => {
                if (res.code == '0') {
                    this.editData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        async exportAccount() { // 导出账号 
            const res = await axios.get(`${process.env.VUE_APP_BASE_API}/api-match-signup/signup/saler/export/account`, { params: {...this.orgData}, headers: { authorization: 'bearer ' + localStorage.getItem(`token`)}, responseType: "blob" })
            let url = window.URL.createObjectURL(new Blob([res.data], { type: "UTF-8" }));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute(
                "download",
                "账号列表.xls",
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link)
        },
        deleteApplyBtn(data) { // 删除申报机构
            this.$confirm('此操作将会删除该计划, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fetch.deleteApply({ applyId: data.id }).then(res => {
                    if (res.code == '0') {
                        this.$message.success(res.msg)
                        this.getMechanismOpenApplyList()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
                this.$message.info('已取消')
            })
        },
        withdrawBtn(type, data) { // 批量撤回 只针对状态为待审核的申请生效 - status == 1
            if (type == 'bath') {
                if (this.idList.length <= 0) {
                    this.$message.error('请批量选择计划撤回')
                } else {
                    let status = [0, 2, 3]
                    let data = this.wantfilterData.filter(item => {
                        if (status.indexOf(item.status) !== -1) {
                            return item
                        }
                    })
                    if (data.length > 0) {
                        this.$message.error('抱歉! 批量撤回只针对状态为待审核的申请生效,请勾选掉其他状态的计划')
                    } else {
                        this.setBommitBack({ schemeId: this.schemeId, idList: this.idList })
                        this.idList = []
                        this.$refs.mechanismBasicTable.$refs.basicTable.$parent.getClearSelect()
                    }
                }
            } else {
                this.setBommitBack({ schemeId: data.schemeId, idList: [data.id] })
            }
        },
        setBommitBack(data) {
            fetch.setBommitBack(data).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getMechanismOpenApplyList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        submitBtn(type, data) { // 批量提交 - status == 0 || 3
            if (type == 'bath') {
                if (this.idList.length <= 0) {
                    this.$message.error('请批量选择计划提交')
                } else {
                    // 申报状态: 
                    // 0 - 未提交 （当为未提交状态时，机构可进行编辑或提交操作)
                    // 1 - 待审批 (当为待审批状态时，机构可进行撤回操作，并且中心可进行 通过/驳回 的操作, 一旦中心操作后，则机构不可进行撤销操作)
                    // 2 - 已通过 (通过后可进行账户的维护)
                    // 3 - 已驳回 (驳回后,机构可进行编辑，并重新提交)
                    let status = [1, 2]
                    let data = this.wantfilterData.filter(item => {
                        if (status.indexOf(item.status) !== -1) {
                            return item
                        }
                    })
                    if (data.length > 0) {
                        this.$message.error('抱歉! 批量提交只针对状态为未提交和已驳回的申请生效,请勾选掉其他状态的计划')
                    } else {
                        this.setCommitApply({ schemeId: this.schemeId, idList: this.idList })
                        this.idList = []
                        this.$refs.mechanismBasicTable.$refs.basicTable.$parent.getClearSelect()
                    }
                }

            } else {
                this.setCommitApply({ schemeId: data.schemeId, idList: [data.id] })
            }
        },
        setCommitApply(data) {
            fetch.setCommitApply(data).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getMechanismOpenApplyList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        operation(type, rowData) {
            if (type == 'selectChange') {
                this.wantfilterData = rowData
                this.idList = rowData.map(item => {
                    return item.id
                })
            }
        },
        resetPasswordBtn(rowData) { // 重制密码
            fetch.setResetPassword({ userId: rowData.userId }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getAccountList({ schemeId: this.rowData.schemeId, orgId: this.rowData.orgId })
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        getDeclareSchemeList() { // 新建申请 - 申报机构下的 大计划下拉
            fetch.getDeclareSchemeList().then(res => {
                if (res.code == '0') {

                    this.selectPlanList = res.data.reverse()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        AddhandleClose() {
            this.addApplyDialogVisible = false
            this.editDialogVisibale = false
            this.accountDialogVisibale = false
            this.planData.id = ''
            this.orgList = []
            this.orgListTwo = []
            this.provinceId = ''
            this.content = ''
            this.raceType = ''
            this.rightData = {
                content: '',
                provinceId: '',
                raceType: ''
            }
            this.editData = {
                phone: '',
                person: ''
            }
            this.checkAll = false
            this.checkAllTwo = false
            this.checkedList = []
            this.planInfoData = {}
            this.OrgTypeList = []
            this.provinceList = []
            this.provinceListTwo = []
            this.orgListThree = []
            this.provinceFormData = {}
            this.isIndeterminate = false
        },
        getProfessionListUrl() { // 专业下拉
            fetch.getProfessionListUrl().then(res => {
                if (res.code == '0') {
                    this.ProfessionList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getOrgTypeListUrl() { // 机构类型下拉
            fetch.getOrgTypeListUrl().then(res => {
                if (res.code == '0') {
                    this.OrgTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getRaceTypeListUrl(val) { // 大赛类型下拉
            fetch.getRaceTypeListUrl({professionId: val}).then(res => {
                if (res.code == '0') {
                    this.RaceTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        async getProvinceList() { // 获取省份
            const res = await fetch.getProvinceList()
            if (res.code == '0') {
                this.provinceData = res.data.map(item => {
                    return { ...item, beginTime: null, endTime: null }
                })
            } else {
                this.$message.error(res.msg)
            }
        },
        currentChange(val) {
            this.limitSize = val.limit
            this.pageNo = val.page
            this.getMechanismOpenApplyList(this.pageNo)
        },
        getMechanismOpenApplyList(page) {
            this.loading = true
            // 0- 未提交 （当为未提交状态时，机构可进行编辑或提交操作)
            // 1- 待审批 (当为待审批状态时，机构可进行撤回操作，并且中心可进行 通过/驳回 的操作, 一旦中心操作后，则机构不可进行撤销操作)
            // 2-已通过 (通过后可进行账户的维护)
            // 3-已驳回 (驳回后,机构可进行编辑，并重新提交)
            let data = {
                0: '未提交',
                1: '待审批',
                2: '已通过',
                3: '已驳回'
            }
            fetch.getPageListApply({ ...this.orgData, pageNo: page || this.pageNo, limitSize: this.limitSize }).then(res => {
                if (res.code == '0') {
                    this.orgData.raceType = ''
                    this.orgData.professionId ? this.getRaceTypeListUrl(this.orgData.professionId) : this.RaceTypeList = []
                    this.total = res.data.total
                    this.tableData = res.data.records.map(item => {
                        return { ...item, statusName: data[item.status] }
                    })
                    this.schemeId = this.tableData[0].schemeId // 保存大计划Id
                    this.loading = false
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                } else {
                    this.$message.error(res.msg)
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleCheckedChange(val) { // 左侧复选框数据
            this.checkedList = val
            if (this.checkedList.length !== this.orgList.length) {
                this.isIndeterminate = true
                this.checkAll = true
            } else {
                this.isIndeterminate = false
            }
        },
        handleCheckedRightChange(val) { // 右侧复选框数据
            this.checkedListTwo = val
            if (this.checkedListTwo.length !== this.orgListTwo.length) {
                if(this.checkedListTwo.length <= 0) {
                    this.isIndeterminateTwo = false
                } else {
                    this.isIndeterminateTwo = true
                }
                this.checkAllTwo = false
            } else {
                this.isIndeterminateTwo = false
                this.checkAllTwo = true
            }
        },
        clearProvinceCopy() {
            // this.orgListTwo = []
            // this.checkedListTwo = []
        }
    },
    components: {
        // BaseSearch: () => import('../../components/baseSearch.vue'),
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue'),
        basicDialog: () => import('@/components/basicDialog.vue')
    }
};
</script>

<style lang="scss" scoped>
.mechanismOpenApply {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPlanDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .formcenter {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        /deep/.el-checkbox {
            display: flex;
            align-items: center;
        }
        // .formLeft {
        //     padding-left: 17px;
        //     box-sizing: border-box;
        // }
        .mechanism {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
        }
        .mechanism_center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .arrow_left {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                margin-bottom: 5px;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
            .arrow_right {
                width: 30px;
                height: 30px;
                color: #fff;
                margin-top: 5px;
                line-height: 30px;
                text-align: center;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .mechanism_left {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanism_right {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanismToptitle {
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #ccc;
            .left_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .right_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
        }
        .mechanismBottomMin {
            width: 100%;
            height: calc(100% - 50px);
        }
        .mechanismSearch {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .mechanismTable {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .mechanismTable2 {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .planInfo {
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            align-content: space-around;
            color: #409eff;
            .planInfo_top {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .left {
                    margin-right: 30px;
                }
            }
        }
        .mechanismOrgName {
            display: inline-block;
            width: 180px;
            height: 33px;
            line-height: 33px;
            overflow-x: hidden;
            overflow-y: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText {
            display: inline-block;
            width: 62px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText2 {
            display: inline-block;
            width: 50px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
    }
    .editDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-left: 150px;
            padding-bottom: 0px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .editCenterTwoBox {
            display: flex;
            justify-content: flex-start;
        }
    }
    .accountDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
            color: #409eff;
        }
    }
    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>